import { sagas as ReportDashboardSagas } from '../features/Dashboard/store/sagas'
import { sagas as ScheduleReportSagas } from '../features/ScheduleReport/store/sagas'
import { sagas as ShareReportSagas } from '../features/ShareReport/store/sagas'
export const sagas = [
  ...ReportDashboardSagas,
  ...ScheduleReportSagas,
  ...ShareReportSagas
]
